import { Locale } from '@ps-smart-cp/ppfw-client';

const sysStateNameConfig = {
  monthlyCarryOver: new Map([
    [Locale.ja, '月次繰越'],
    [Locale.en, 'Monthly Carry Over'],
  ]),
  carryOverBeginningYear: new Map([
    [Locale.ja, '期首繰越'],
    [Locale.en, 'Carry Over Beginning Year'],
  ]),
  carryOverAdjustmentPeriod: new Map([
    [Locale.ja, '調整期間繰越'],
    [Locale.en, 'Carry Over Adjustment Period'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { sysStateNameConfig };
